import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CorsoDetailsCard from '../../components/CorsoDetailsCard/CorsoDetailsCard';
import UtilityService from '../../services/UtillityServices/UtilityService';
import useMediaQuery from '../../hooks/useMediaQuery';
import { Spinner } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import useClassi from '../../hooks/useClassi';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';

const CorsoDetailsPage = () => {
    const location = useLocation();
    const {getClassiByParamsNoAuth, loadingStateClassi} = useClassi();
    const { getClassiUtenteByToken, loadingStateClassiUtenti } = useClassiUtenti();
    const user = useSelector((state) => state.user?.userData);
    const courseDataState = location.state && location.state.courseData;
    const [courseData, setCourseData] = useState(courseDataState)
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
      setCourseData(courseDataState)
    }, [courseDataState])

    useEffect(() => {
      if(!courseData) {
        fetchCorsoById();
      }
    }, [location.pathname])

    const renderHtml = (content) => {
      const config = {
        ALLOWED_TAGS: [
          'p', 'br', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li',
          'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'
        ],
        ALLOWED_ATTR: ['href', 'target', 'style', 'class'],
        KEEP_CONTENT: true
      };
      
      return { __html: DOMPurify.sanitize(content, config) };
    };

    
    const fetchCorsoById = async () => {
      try {
        const parts = location.pathname.split('/');
        const classId = parts[2]; 
        const fetchClasse = await getClassiByParamsNoAuth({
          filtri: {
            id_classe: classId
          }
        });
        if(fetchClasse?.data[0]?.stato === 'Inattivo') {
          navigate('/corsi');
          return;
        }
        let pagato = false;
        let sconto = 0;
        let scontoAttivo = false;
        let stato_pagamento = null;

        if (user?.sub && user?.role === ROLES.CORSISTA) {
          const purchasedClassi = await getClassiUtenteByToken();
          const purchasedClasse = purchasedClassi.find(
            classe => Number(classe.id_classe) === Number(classId)
          );
          
          if (purchasedClasse) {
            pagato = purchasedClasse.stato_pagamento === 'Pagato';
            sconto = purchasedClasse.sconto || 0;
            scontoAttivo = purchasedClasse.sconto_corsista === 1;
            stato_pagamento = purchasedClasse.stato_pagamento;
          }
        }

        const data = {
          ...fetchClasse?.data[0].corso,
          data_inizio_classe: fetchClasse?.data[0].data_inizio,
          data_fine_classe: fetchClasse?.data[0].data_fine,
          docenti: fetchClasse?.data[0].docenti,
          sede: fetchClasse?.data[0].sede,
          id_classe: classId,
          pagato,
          sconto,
          scontoAttivo,
          stato_pagamento,
          numero_iscritti: fetchClasse?.data[0]?.numero_iscritti,
          numero_massimo_corsisti: fetchClasse?.data[0]?.numero_massimo_corsisti
        };

        setCourseData(data);
      } catch (error) {
        console.error("Errore nel caricamento del corso:", error);
      }
    };
  
    useEffect(() => {
      const handleScroll = () => {
        const scrolled = window.scrollY > 250;
        if (scrolled !== isScrolled) {
          setIsScrolled(scrolled);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [isScrolled]);

    const printDocenti = () => {
      if (courseData?.docenti && courseData.docenti?.length > 0) {
        const docentiNames = courseData.docenti?.map(docente => `${docente.nome} ${docente.cognome}`).join(', ');
        return courseData.docenti?.length > 1 ? `Docenti: ${docentiNames}` : `Docente: ${docentiNames}`;
      } else {
        return 'Docente: non assegnato';
      }
    };

    if (!courseData && (loadingStateClassi.isLoadingClassiByParamsNoAuth || loadingStateClassiUtenti.isLoadingClassiUtenteByToken)) {
      return (
        <div
          className={"d-flex align-items-center justify-content-center vh-100"}>
          <Spinner />
        </div>
      );
    }

    const renderText = (name, label) => (
      name && (
        <>
          <b className='fs-4 mt-3 mb-1 d-block'>{label || ''}</b>
          <div dangerouslySetInnerHTML={renderHtml(name)} />
        </>
     )
  )

    return (
      <div className='bg-light min-vh-100'>
      <div className='bg-dark text-light' style={{padding: '30px 0'}}>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-12 col-xl-3'>
              <div className={`${isWideScreen && !isScrolled ? 'position-absolute' : ''} ${isWideScreen  && isScrolled ? 'position-fixed' : ''}`}>
              <CorsoDetailsCard courseData={courseData}/>
              </div>
            </div>
            <div className='col-sm-12 col-md-12 col-xl-9'>
              <div className={`${isWideScreen ? 'px-5' : ''} py-2`}>
                <div className="text-light">
              <h2>{courseData?.denominazione}</h2>
                  <p className='mt-3'>{courseData?.descrizione}</p>
                  <p className="my-3"><i className="bi bi-person-fill"></i> {printDocenti()}</p>
                  <p className="small"><i className="bi bi-patch-exclamation-fill"></i> Ultimo aggiornamento in data {UtilityService.formatDateAndHour(courseData?.data_modifica)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-light text-dark'>
      <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-12 col-xl-3'>
           
            </div>
            <div className='col-sm-12 col-md-12 col-xl-9'>
              <div className={`${isWideScreen ? 'px-5' : ''} py-2`}>
                <div className="text-dark">
                  {renderText(courseData?.note, 'Descrizione')}
                  {courseData?.certificazione && (<span><b className='fs-4 mt-3 mb-1 d-block'>Certificazione</b>{courseData?.certificazione?.descrizione}</span>)}
                  {courseData?.modalita_erogazione && (<span><b className='fs-4 mt-3 mb-1 d-block'>Modalità erogazione</b>{UtilityService.getModalitaErogazione(courseData.modalita_erogazione)}</span>)}
                  {courseData?.sede?.descrizione && (<span><b className='fs-4 mt-3 mb-1 d-block'>Sede</b>{courseData?.sede?.descrizione}</span>)}
                  {renderText(courseData?.fruizione_corso, 'Fruizione')}
                  {/* {courseData?.fruizione_corso && (<span><b className='fs-4 mt-3 mb-1 d-block'>Fruizione</b>{courseData?.fruizione_corso}</span>)} */}
                  {courseData?.data_inizio_classe && (<span><b className='fs-4 mt-3 mb-1 d-block'>Data inizio</b>{UtilityService.formatDate(courseData.data_inizio_classe)}</span>)}
                  {courseData?.data_fine_classe && (<span><b className='fs-4 mt-3 mb-1 d-block'>Data fine</b>{UtilityService.formatDate(courseData.data_fine_classe)}</span>)}
{/*                   {courseData?.istruzioni_svolgimento_corso && (<span><b className='fs-4 mt-3 mb-1 d-block'>Istruzioni svolgimento corso</b>{courseData.istruzioni_svolgimento_corso}</span>)} */}
                  {renderText(courseData?.istruzioni_svolgimento_corso, 'Istruzioni svolgimento corso')}
                  {renderText(courseData?.esame, 'Esame')} 
                  {renderText(courseData?.istruzioni_svolgimento_esame, 'Istruzioni svolgimento esame')} 
                  {renderText(courseData?.contratto_formativo, 'Contratto formativo')} 
                  {renderText(courseData?.obiettivo, 'Obiettivo')} 
                  {renderText(courseData?.argomento, 'Argomento')} 
                  {renderText(courseData?.strumento_supporto, 'Strumenti di supporto')} 
                  {renderText(courseData?.struttura, 'Struttura')} 
                  {renderText(courseData?.frequenza, 'Frequenza')} 

             {/*      {courseData?.esame && (<span><b className='fs-4 mt-3 mb-1 d-block'>Esame</b>{courseData.esame}</span>)} */}
                  {/* {courseData?.istruzioni_svolgimento_esame && (<span><b className='fs-4 mt-3 mb-1 d-block'>Istruzioni svolgimento esame</b>{courseData.istruzioni_svolgimento_esame}</span>)} */}
                  {courseData?.titolo_studio_min && (<span><b className='fs-4 mt-3 mb-1 d-block'>Titolo di studio minimo</b>{courseData.titolo_studio_min}</span>)}
                  {courseData?.perc_assenze_max && (<span><b className='fs-4 mt-3 mb-1 d-block'>Massimo percentuale assenze</b>{Math.round(courseData.perc_assenze_max)}%</span>)}
                {/*   {courseData?.contratto_formativo && (<span><b className='fs-4 mt-3 mb-1 d-block'>Contratto formativo</b>{courseData.contratto_formativo}</span>)} */}
                  {/* {courseData?.obiettivo && (<span><b className='fs-4 mt-3 mb-1 d-block'>Obiettivo</b>{courseData.obiettivo}</span>)}
                  {courseData?.argomento && (<span><b className='fs-4 mt-3 mb-1 d-block'>Argomento</b>{courseData.argomento}</span>)} */}
{/*                   {courseData?.strumento_supporto && (<span><b className='fs-4 mt-3 mb-1 d-block'>Strumenti di supporto</b>{courseData.strumento_supporto}</span>)} */}
                  {courseData?.durata && (<span><b className='fs-4 mt-3 mb-1 d-block'>Durata</b>{courseData.durata} {courseData.durata == "1" ? "ora" : "ore"}</span>)}
                 {/*  {courseData?.struttura && (<span><b className='fs-4 mt-3 mb-1 d-block'>Struttura</b>{courseData.struttura}</span>)}
                  {courseData?.frequenza && (<span className='mb-4 d-block'><b className='fs-4 mt-3 mb-1 d-block'>Frequenza</b>{courseData.frequenza}</span>)} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
}

export default CorsoDetailsPage;
